import CheckboxGroup from 'common/components/checkbox/CheckboxGroup'
import RadioGroup from 'common/components/radioGroup'

type Props = {
  data: any
  defaultValue: string | undefined
  disabled?: boolean
  onChange: Function
}

const SingleSelectRadioCheckbox = ({
  data,
  defaultValue,
  disabled,
  onChange,
}: Props) => {
  const hasOnlyOneOption = data.option_list.length === 1

  return (
    <>
      {hasOnlyOneOption ? (
        <CheckboxGroup
          onChange={(e) => {
            const newValue = e.target.checked ? e.target.value : ''

            onChange(data.name, data.type, newValue, data.required, {
              max_limit: data.max_limit,
            })
          }}
          options={data.option_list.map((option) => ({
            label: option[0],
            value: option[1] ?? option[0],
            isChecked: defaultValue === option[1] ?? option[0],
            isDisabled: disabled,
          }))}
        />
      ) : (
        <RadioGroup
          data-cy={data.type}
          name={data.name}
          onChange={(newValue) => {
            onChange(data.name, data.type, newValue, data.required, {
              max_limit: data.max_limit,
            })
          }}
          value={defaultValue}
          options={data.option_list.map((option) => ({
            label: option[0],
            value: option[1] ?? option[0],
          }))}
          isDisabled={disabled}
          variant="withBackground"
        />
      )}
    </>
  )
}

export default SingleSelectRadioCheckbox
